import type { FC } from 'react';
import { useFooterCtaCopy } from '../../lib/footer-cta-context';

type CtaBandProps = {
  onInquire: () => void;
};

const CtaBand: FC<CtaBandProps> = ({ onInquire }) => {
  const { heading, text } = useFooterCtaCopy();

  return (
    <div className="pre-footer__cta">
      <div className="pre-footer__container pre-footer__cta-inner">
        <h2 className="pre-footer__cta-heading">{heading}</h2>
        <p className="pre-footer__cta-text">{text}</p>
        <div className="pre-footer__cta-actions">
          <button
            className="pre-footer__cta-btn pre-footer__cta-btn--primary"
            onClick={onInquire}
            type="button"
          >
            INQUIRE NOW
          </button>
          <a
            className="pre-footer__cta-btn pre-footer__cta-btn--outline"
            href="mailto:sales@sahilcnc.com"
          >
            REQUEST CATALOG
          </a>
        </div>
      </div>
    </div>
  );
};

export default CtaBand;
